<template>
	<div v-if="!hideWarning" class="alert alert-warning text-center" :class="{ 'hide': hideWarning}" role="alert">
		<svgIcon iconHolderClass="icon-warning" iconId="icon-warning"/>
		{{ warningMessage }}
		<slot/>
	</div>
</template>

<script>
import svgIcon from './icon-svg';

export default {
	name: 'formWarning',
	components: {
		svgIcon
	},
	props: {
		hideWarning: {
			type: Boolean,
			default: true,
			note: 'Hide and show warning'
		},
		warningMessage: {
			type: String,
			default: '',
			note: 'Message when it shows.'
		}
	},
};
</script>

<style lang="less" scoped>
	.alert {
		position: fixed;
		width: 100%;
	}
	@media (max-width: 740px) {
		.alert {
			position: relative;
			margin-bottom: 0;
		}
	}
</style>
